// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3R7In","question":"Question_question__Lq39y","description":"Question_description__dfFcs"};